/* SETTINGS */
export const SHOW_POPUP = "SHOW_POPUP"
export const HIDE_POPUP = "HIDE_POPUP"

export const SET_DATA_EDIT = "SET_DATA_EDIT"
export const SET_DATA = "SET_DATA"
export const REMOVE_DATA = "REMOVE_DATA"

